import { render } from "./tierContainer.vue?vue&type=template&id=b33ce2b0&scoped=true"
import script from "./tierContainer.vue?vue&type=script&lang=js"
export * from "./tierContainer.vue?vue&type=script&lang=js"

import "./tierContainer.vue?vue&type=style&index=0&id=b33ce2b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33ce2b0"]])

export default __exports__